import { Routes, Route, Navigate } from "react-router-dom";
import { useKitchenStore } from "./stores/kitchen.store";
import Login from "./views/Login";
import SelectClient from "./views/SelectClient";
import ChefOverview from "./views/ChefOverview";
import CustomerMenu from "./views/CustomerMenu";
import StationView from "./views/StationView";
import PaymentSuccess from "./views/PaymentSuccess";
import PaymentCancelled from "./views/PaymentCancelled";
import AudioUnlockOverlay from "./components/AudioUnlockOverlay";

function AuthGuard({ children }: { children: React.ReactNode }) {
  const jwtToken = useKitchenStore((s) => s.jwtToken);
  const clientId = useKitchenStore((s) => s.clientId);

  if (!jwtToken || !clientId) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

export default function App() {
  return (
    <>
      <AudioUnlockOverlay />
      <Routes>
        {/* Auth */}
        <Route path="/login" element={<Login />} />
        <Route path="/select-client" element={<SelectClient />} />

        {/* Protected routes */}
        <Route path="/" element={<AuthGuard><ChefOverview /></AuthGuard>} />
        <Route path="/station/:stationId" element={<AuthGuard><StationView /></AuthGuard>} />

        {/* Public customer menu - QR token in URL */}
        <Route path="/menu/:token" element={<CustomerMenu />} />

        {/* Payment result pages - customer-facing */}
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancelled" element={<PaymentCancelled />} />
      </Routes>
    </>
  );
}
